import { Card } from "@tfg/ui"

import { OnboardingProvider } from "~/pages/SupplierPortal/Onboarding/OnboardingContext"
import { OnboardingStepperShell } from "~/pages/SupplierPortal/Onboarding/OnboardingStepperShell"

export const SupplierOnboardingPage = () => {
  return (
    <Card mih="calc(100vh - var(--mantine-supplier-header-height))">
      <OnboardingProvider>
        <OnboardingStepperShell />
      </OnboardingProvider>
    </Card>
  )
}
